if (__DEV__) {
  try {
    require('./src/lib/reactotron').configureReactotron();
  } catch (error) {
    console.warn('Reactotron disabled due to initialization error:', error);
  }
}

import 'expo-router/entry';
